"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validations_1 = require("../../utils/validations");

var EncryptedGroupKey = /*#__PURE__*/function () {
  /**
   * A pair (groupKeyId, encryptedGroupKey) where the encryptedGroupKey is an encrypted, hex-encoded version of the group key.
   * @param groupKeyId
   * @param encryptedGroupKeyHex
   * @param serialized Optional. If given, this exact string is returned from serialize().
   */
  function EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex) {
    var serialized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, EncryptedGroupKey);

    validations_1.validateIsString('groupKeyId', groupKeyId);
    this.groupKeyId = groupKeyId;
    validations_1.validateIsString('encryptedGroupKeyHex', encryptedGroupKeyHex);
    this.encryptedGroupKeyHex = encryptedGroupKeyHex;
    validations_1.validateIsString('serialized', serialized, true);
    this.serialized = serialized;
  }

  _createClass(EncryptedGroupKey, [{
    key: "toArray",
    value: function toArray() {
      return [this.groupKeyId, this.encryptedGroupKeyHex];
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // Return the cached serialized form to ensure that it stays unchanged (important for validation)
      if (this.serialized) {
        return this.serialized;
      }

      return JSON.stringify(this.toArray());
    }
  }], [{
    key: "deserialize",
    value: function deserialize(json) {
      var _JSON$parse = JSON.parse(json),
          _JSON$parse2 = _slicedToArray(_JSON$parse, 2),
          groupKeyId = _JSON$parse2[0],
          encryptedGroupKeyHex = _JSON$parse2[1];

      return new EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex, json);
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr = _slicedToArray(arr, 2),
          groupKeyId = _arr[0],
          encryptedGroupKeyHex = _arr[1];

      return new EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex);
    }
  }]);

  return EncryptedGroupKey;
}();

exports.default = EncryptedGroupKey;